/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCFPBSettlementCaseRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {CreateCFPBSettlementCaseResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const createCFPBSettlementCase = (request:CreateCFPBSettlementCaseRequest, options?: CashRequestOptions) => post<CreateCFPBSettlementCaseRequest, CreateCFPBSettlementCaseResponse>("/cash-app/complaints/create-cfpb-settlement-case", request, {...options, rejectOnError: true })